// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8364) return "static/chunks/8364-bd8b27c89925f0c6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "65e0411f4ecc285a" + ".js";
};